import * as React from "react";
const SvgNotificationBell = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "1em", height: "1em", viewBox: "0 0 256 256", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  stroke: "none",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "none",
  fillRule: "nonzero",
  opacity: 1
}, transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" }, /* @__PURE__ */ React.createElement("path", { d: "M 45 0 C 20.187 0 0 20.187 0 45 c 0 24.813 20.187 45 45 45 c 24.813 0 45 -20.187 45 -45 C 90 20.187 69.813 0 45 0 z M 45 72.621 c -3.948 0 -7.148 -3.2 -7.148 -7.148 c 0 -0.016 0.002 -0.03 0.002 -0.046 h 14.291 c 0 0.016 0.002 0.03 0.002 0.046 C 52.148 69.421 48.948 72.621 45 72.621 z M 63.435 60.927 H 26.565 c -1.857 0 -3.368 -1.511 -3.368 -3.368 c 0 -2.16 0.942 -4.203 2.584 -5.605 c 0.974 -0.832 1.533 -2.043 1.533 -3.324 V 35.065 c 0 -9.752 7.934 -17.686 17.686 -17.686 s 17.687 7.934 17.687 17.686 v 13.564 c 0 1.281 0.559 2.493 1.532 3.324 c 1.642 1.401 2.584 3.445 2.584 5.605 C 66.803 59.416 65.292 60.927 63.435 60.927 z", style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "#041b53",
  fillRule: "nonzero",
  opacity: 1
}, transform: " matrix(1 0 0 1 0 0) ", strokeLinecap: "round" })));
export default SvgNotificationBell;
